import { useModal } from "@pulse/hooks/contextHooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/sharp-regular-svg-icons";

function SecondaryModal() {
    const { secondaryVisible, secondaryContent, closeSecondaryModal } = useModal();
    if (!secondaryVisible) return null;
    return (
        <div
            className={`w-full h-full fixed  z-50 ${
                !secondaryContent?.disableBlurredBg && "backdrop-blur-[2px] bg-black/20"
            } flex justify-center items-center transition-all ease-in-out duration-300`}
        >
            <div
                className="bg-container text-on-container rounded-lg border border-container-outline w-content"
                onMouseDown={(e) => e.stopPropagation()}
            >
                <div
                    className={
                        secondaryContent?.title
                            ? `text-2xl font-bold border-b border-container-outline w-full p-4 flex justify-between items-center`
                            : `text-2xl  p-2 text-right w-full h-0`
                    }
                >
                    {secondaryContent?.title && <h1>{secondaryContent.title}</h1>}
                    {!secondaryContent?.disableXButton && (
                        <FontAwesomeIcon
                            icon={faXmark}
                            className="cursor-pointer opacity-70 hover:opacity-50"
                            onClick={closeSecondaryModal}
                            size="xl"
                        />
                    )}
                </div>

                <div className="p-4">{secondaryContent?.children}</div>
            </div>
        </div>
    );
}

export default SecondaryModal;
